import PropTypes from 'prop-types';
import React from 'react';
import ReactPaginate from 'react-paginate';
import s from './PaginationOrganization.module.scss';
import classNames from 'classnames';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const PaginationOrganization = ({
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  isNewsListPage = false,
}) => {
  const { t } = useTranslation();

  const handlePageChange = (selectedItem) => {
    const page = selectedItem.selected + 1;
    onPageChange(page);

    setTimeout(() => {
      const element = document.getElementById('top-of-search');
      if (!element) return;

      const elementPosition =
        element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - 20;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }, 50);
  };

  if (totalPages <= 1) return null;
  return (
    <div className={classNames(s.Root, { [s.NewsListPage]: isNewsListPage })}>
      <ReactPaginate
        forcePage={currentPage - 1}
        onPageChange={handlePageChange}
        hrefAllControls={true}
        containerClassName={s.List}
        pageClassName={s.Item}
        pageLinkClassName={s.Link}
        breakClassName={s.Break}
        activeClassName={classNames(s.Link, s.LinkActive)}
        previousLinkClassName={classNames(s.Link)}
        nextLinkClassName={classNames(s.Link)}
        previousClassName={classNames(s.Item, s.ItemChevron, s.ItemChevronLeft)}
        nextClassName={classNames(s.Item, s.ItemChevron, s.ItemChevronRight)}
        disabledClassName={classNames(s.Item, s.LinkDisabled)}
        disabledLinkClassName={classNames(s.Link, s.LinkDisabled)}
        previousAriaLabel={t('Common.pagination.previousPage')}
        nextAriaLabel={t('Common.pagination.nextPage')}
        breakLabel="..."
        pageRangeDisplayed={2}
        marginPagesDisplayed={1}
        pageCount={totalPages}
        previousLabel={
          <div className={s.IconWrapper}>
            <Image
              width={24}
              height={24}
              src={`/img/icon-chevron-left-white.svg`}
              alt=""
              className={s.Icon}
            />
          </div>
        }
        nextLabel={
          <div className={s.IconWrapper}>
            <Image
              width={24}
              height={24}
              src={`/img/icon-chevron-right-white.svg`}
              alt=""
              className={s.Icon}
            />
          </div>
        }
        renderOnZeroPageCount={null}
      />
    </div>
  );
};

PaginationOrganization.propTypes = {
  totalPages: PropTypes.number,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
};

export default PaginationOrganization;
